import React, { useEffect, useState } from "react";
import ReactTable from "react-table";
import { buildColumns } from "admin/resubmit-upc/lib/constants";

const UpcList = ({ upcList, resubmitUpc, clearSelected, disabled }) => {
    const [selectedUpcs, setSelectedUpcs] = useState([]);

    useEffect(() => {
        if (clearSelected) {
            setSelectedUpcs([]);
        }
    }, [clearSelected]);

    const updateSelectedUpc = (item, isRemove) => {
        if (isRemove === "true") {
            setSelectedUpcs(selectedUpcs.filter((i) => item.key !== i.key));
        } else {
            setSelectedUpcs([...selectedUpcs, { ...item }]);
        }
    };

    const setAllUpcs = (list) => {
        setSelectedUpcs(list);
    };

    const handleClick = async () => {
        const keyList = selectedUpcs.map((i) => i.key);
        const response = await resubmitUpc(keyList);

        if (response) {
            setAllUpcs([]);
        }
    };

    const keyList = selectedUpcs.map((i) => i.key);
    const isListPopulated = keyList.length > 0;

    return (
        <>
            <ReactTable data={upcList} columns={buildColumns(updateSelectedUpc, setAllUpcs, keyList)} minRows="5" />
            {isListPopulated && (
                <button className="button -primary" onClick={handleClick} disabled={disabled}>
                    Resubmit UPCs
                </button>
            )}
        </>
    );
};

export default UpcList;
